import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    printListAuto: false,
    // BaseWsUrl: 'wss://api.hapi-lot.com',
    BaseWsUrl: 'ws://127.0.0.1:9999',
    WsMain: null,
    WsLimit: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_PRINTLIST(state, val) {
      state.printListAuto = val
    },
    SET_WSMAIN(state, val) {
      state.WsMain = val
    },
    SET_WSLIMIT(state, val) {
      state.WsLimit.push(val)
    },
  },
  actions: {},
}
